import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CreateBusinessLoansForm } from "web_myplann/Portfolio/Pages/BusinessLoansCreate/CreateBusinessLoansForm";
import { PortfolioAddLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddLayout";

export const AddBusinessLoansPage = () => {
	const { t } = useResource();

	return (
		<PortfolioAddLayout title={t(Resources.Portfolio.AddBusinessLoans.title)}>
			<CreateBusinessLoansForm />
		</PortfolioAddLayout>
	);
};
